import {
  GetDisplayOptionsRawResponse,
  GetDisplayOptionsResponse,
  UpdateDisplayOptionsRawResponse,
  UpdateDisplayOptionsResponse,
} from "./types";

const toBool = (value: unknown): boolean => value === true || value === "true" || value === 1 || value === "1";

export const transformDisplayOptions = (res: GetDisplayOptionsRawResponse) => {
  const { _links, ...displayOptions } = res;
  const response: GetDisplayOptionsResponse = {
    data: {
      details: {
        bookingMaxNumberOfStops: displayOptions.enabled_booking_max_number_of_stops,
        enabledBookingHistoryDisplayOperatorIdentifier: toBool(displayOptions.enabled_booking_history_display_operator_identifier),
        enabledBookingHistoryUseOptimizedWideDisplay: toBool(displayOptions.enabled_booking_history_use_optimized_wide_display),
        enabledBookingManagerDashboardNoteFunctionality: toBool(displayOptions.enabled_booking_manager_dashboard_note_functionality),
        pricingClientInvoiceDisplayDisabled: toBool(displayOptions.enabled_pricing_client_invoice_display_disabled),
        pricingInvoiceCreditCardMixingDisabled: toBool(displayOptions.enabled_pricing_invoice_credit_card_mixing_disabled),
      },
    },
    links: _links,
  };

  return response;
};

export const transformUpdateDisplayOptions = (res: UpdateDisplayOptionsRawResponse) => {
  return {
    links: res._links,
  } as UpdateDisplayOptionsResponse;
};
